import { useEffect } from 'react';
import { MONKEY_USER_ID } from '../../../constants/monkey';
import type { ParticipantTab } from '../types/create.types';
import type { Group } from '../../../types/challenges';

interface UseGuestMonkeyGuardProps {
  isGuestMonkeyCreateFlow: boolean;
  selectedFriendId: string | null;
  selectedGroupId: string | null;
  activeTab: ParticipantTab;
  setSelectedFriendId: (id: string | null) => void;
  setSelectedGroupId: (id: string | null) => void;
  setSelectedGroup: (group: Group | null) => void;
  setActiveTab: (tab: ParticipantTab) => void;
}

export const useGuestMonkeyGuard = ({
  isGuestMonkeyCreateFlow,
  selectedFriendId,
  selectedGroupId,
  activeTab,
  setSelectedFriendId,
  setSelectedGroupId,
  setSelectedGroup,
  setActiveTab,
}: UseGuestMonkeyGuardProps): void => {
  useEffect(() => {
    if (!isGuestMonkeyCreateFlow) return;
    setSelectedFriendId(MONKEY_USER_ID);
    setActiveTab('friends');
    setSelectedGroupId(null);
    setSelectedGroup(null);
  }, [
    isGuestMonkeyCreateFlow,
    setSelectedFriendId,
    setActiveTab,
    setSelectedGroupId,
    setSelectedGroup,
  ]);

  useEffect(() => {
    if (!isGuestMonkeyCreateFlow) return;
    if (selectedFriendId !== MONKEY_USER_ID) {
      setSelectedFriendId(MONKEY_USER_ID);
    }
    if (selectedGroupId) {
      setSelectedGroupId(null);
      setSelectedGroup(null);
    }
    if (activeTab !== 'friends') {
      setActiveTab('friends');
    }
  }, [
    isGuestMonkeyCreateFlow,
    selectedFriendId,
    selectedGroupId,
    activeTab,
    setSelectedFriendId,
    setSelectedGroupId,
    setSelectedGroup,
    setActiveTab,
  ]);
};
